module.exports = __webpack_public_path__ + "static/media/1619_FlowerbedMaint.13cbb7c4.JPG";